import { computed, Ref, ref } from "vue";
import { DetailData } from "@/types/Syain";
import { useRoute } from "vue-router";
import { SyainService } from "@/service/SyainService";

/*
 * 初期処理
 */
export function useSyainDetail() {
  const route = useRoute()
  const userId = ref(parseInt(route.params.id as string, 10))
  const syainDetail: Ref<DetailData> = ref(new DetailData())

  const syainSrv = new SyainService();

  const loading = ref(0) // APIで読み込みをする本数
  const isError = ref(false)

  // 社員情報取得
  const getSyainDetail = async (userId: number) => {
    loading.value++
    const res = await syainSrv.getInfo(userId)
    syainDetail.value = res
    loading.value--
  }

  // 読み込み中か判断する
  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value)
  })

  const getSyozokuSyouninGroup = async (userId: number) => {
    loading.value++
    const srv = new SyainService()
    const res = await srv.getSyozokuSyouninGroup(userId)
    loading.value--
    return res
  }

  const setUserId = async (id: number) => {
    userId.value = id
  }

  return {
    syainDetail,
    userId,
    isError,
    isLoading,
    getSyainDetail,
    setUserId,
    getSyozokuSyouninGroup
  }
}